module.exports = __webpack_public_path__ + "static/media/site_infomap.14488b28.png";